import type { RecipeStep } from 'types/Recipes';

const parseRecipeStep = (step: any): RecipeStep => {
  const parsedRecipeStep: any = {
    isStep: step.IsStep,
    title: step.Title,
    description: step.Description,
    images: step.Images,
    videos: step.Videos,
    cookingType: step.CookingType?.Title,
    ovenTimeMinutes: step.FromOvenHeatingTimeInMinutes,
    fanOvenTemp: step.FanAssistedOvenTemperatureInCelsiusSummaryText,
    conventionalOvenTemp: step.TopAndBottomHeatOvenTemperatureInCelsiusSummaryText,
    rackPosition: step.RackPosition?.Title,
    cookingSummaryText: step.CookingSummaryText,
    ingredients: step.Ingredients,
  };

  // Remove undefined elements
  Object.keys(parsedRecipeStep).forEach((k) => {
    parsedRecipeStep[k] === undefined && delete parsedRecipeStep[k];
  });

  return parsedRecipeStep;
};

export default parseRecipeStep;
